import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-487752d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "row row--tax-offices" }
const _hoisted_3 = { class: "row--tax-offices__header" }
const _hoisted_4 = {
  class: "tax-offices-list",
  "cy-data": "office-list"
}
const _hoisted_5 = ["data-id", "onClick", "onKeydown"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("form", {
    style: _normalizeStyle({ display: _ctx.isOpen ? 'block' : 'none' }),
    class: "form form--tax-office-list-field tax-office-list-field field--tax-office-list",
    onSubmit: _withModifiers(($event: any) => (null), ["prevent"])
  }, [
    _createElementVNode("button", {
      type: "button",
      class: "tax-office-list-field__close",
      "aria-label": "Close tax offices list",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.taxOffices`)), 1),
      _createVNode(_component_Field, {
        modelValue: _ctx.formData.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.value = $event)),
        type: "search",
        name: "tax-office",
        placeholder: _ctx.$t(`${_ctx.TRANSLATION_KEY}.searchPlaceholder`),
        "cy-data": "search-field",
        "no-auto-validation": true
      }, null, 8, ["modelValue", "placeholder"]),
      _createElementVNode("ul", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTaxOffices, (value) => {
          return (_openBlock(), _createElementBlock("li", {
            key: value[0],
            "data-id": value[0],
            tabindex: "0",
            role: "button",
            class: "tax-office-list-field__option",
            onClick: ($event: any) => (_ctx.setValue(value[0], value[1])),
            onKeydown: [
              _withKeys(_withModifiers(($event: any) => (_ctx.setValue(value[0], value[1])), ["prevent"]), ["enter"]),
              _withKeys(_withModifiers(($event: any) => (_ctx.setValue(value[0], value[1])), ["prevent"]), ["space"])
            ]
          }, _toDisplayString(value[1]), 41, _hoisted_5))
        }), 128))
      ])
    ])
  ], 44, _hoisted_1))
}